import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

// bycursor-start
/**
 * 获取开发环境Token
 * @author bycursor
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken
    ? `Bearer ${customToken}`
    : `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc3MjUwNDI5NDU0MiwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTAxODcyIn0.Lgnf9a-MepDfc8pMT3hcR7OlT7KCbFPcXSo4mqAXT8eauOyNq-xxSgITSXFzbCuYiNhSSDrIVDMYrfFTdDR-6w`;
};
// bycursor-end

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';

// Contains cursor-generated edits.
